import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth, formatApiErrorDetail } from "../context/AuthContext";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const { loginUser } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await loginUser(email, password);
      toast.success("Welcome back");
      navigate(u.role === "admin" ? "/admin" : "/dashboard");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen flex items-center justify-center relative z-10 px-6 pt-28 pb-16">
      <div className="w-full max-w-md">
        <p className="overline text-[#9A7420] mb-3 text-center">Member Access</p>
        <h1 className="font-display text-5xl tracking-tight text-center mb-10">Welcome back</h1>
        <form data-testid="login-form" onSubmit={submit} className="space-y-7">
          <div>
            <label className="overline block mb-2">Email</label>
            <input data-testid="login-email" type="email" required className="input-line" value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div>
            <label className="overline block mb-2">Password</label>
            <input data-testid="login-password" type="password" required className="input-line" value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          <button data-testid="login-submit" type="submit" disabled={loading} className="btn-primary w-full justify-center">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Sign In"}
          </button>
        </form>
        <p className="text-center mt-4">
          <Link to="/forgot-password" data-testid="go-forgot" className="text-sm text-[#57515F] hover:text-[#9A7420] underline underline-offset-4">
            Forgot password?
          </Link>
        </p>
        <p className="text-center text-[#57515F] mt-6">
          New here?{" "}
          <Link to="/register" data-testid="go-register" className="text-[#9A7420] underline">Create an account</Link>
        </p>
      </div>
    </main>
  );
}
